<!--投資組合-->
<template>
	<div class="page-body center-wrap">
		<titleModel></titleModel>
		<el-tabs v-model="status">
			<el-tab-pane :label="$t('进行中')" name="1"></el-tab-pane>
			<el-tab-pane :label="$t('已完成')" name="2"></el-tab-pane>
		</el-tabs>
		<div class="list-page">
			<div class="th-div">
				<span class="column">{{ $t('投资组合') }}</span>
				<span class="column">{{ $t('申购金额') }}</span>
				<span class="column">{{ $t('当前收益') }}</span>
				<span class="column">{{ $t('开始时间') }}</span>
				<span class="column">{{ $t('结束时间') }}</span>
				<span class="column">{{ $t('状态') }}</span>
				<span class="column">{{ $t('投资组合') }}</span>
				<!-- <span class="column">{{ $t('操作') }}</span> -->
			</div>
			<div class="tr-div" v-if="list.length > 0">
				<div class="row" v-for="item in list" :key="item.id">
					<span class="column" style="color: rgb(222, 169, 33);">{{ item.title }}</span>
					<span class="column">{{ Number(item.amount) || '0.00' }}</span>
					<span class="column" style="display: flex; flex-direction: row; align-items: center;">
						<span style="color: rgb(0, 240, 240);">{{ Number(item.profit) || '0.00' }}</span>
						<span class="svg-container svg-img white" style="margin-top: 4px;">
							<svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"
								class="svg-class">
								<g id="Frame">
									<path id="Vector"
										d="M12.4986 4.79406V2.60156H3.52177V4.79406H6.83125V6.22648C4.14102 6.34747 2.11523 6.87778 2.11523 7.51405C2.11523 8.15033 4.141 8.68061 6.83125 8.80161V13.3987H9.18916V8.80053C11.869 8.67772 13.8845 8.14838 13.8845 7.51403C13.8845 6.87961 11.869 6.35009 9.18916 6.22744V4.79405H12.4986V4.79406ZM12.871 7.38452C12.871 7.80298 11.3046 8.154 9.18916 8.25145L9.05245 8.25725H9.03734L8.90916 8.26197H8.89528C8.79994 8.26523 8.70344 8.26803 8.60572 8.27023H8.59966L8.46858 8.27295H8.43153L8.32809 8.27434H7.67305L7.57067 8.27295H7.53511L7.41281 8.27039H7.39937C7.25442 8.26716 7.11166 8.26269 6.971 8.25725H6.96916L6.82912 8.25119C4.70317 8.15522 3.12666 7.80298 3.12666 7.38252C3.12666 6.96195 4.70344 6.61077 6.82912 6.51373V7.84353C7.19814 7.86277 7.59069 7.87331 7.99781 7.87331C8.41142 7.87331 8.81189 7.86259 9.18712 7.84247V6.51769C11.3044 6.61489 12.871 6.96608 12.871 7.38452Z">
									</path>
								</g>
							</svg>
						</span>
					</span>
					<span class="column">{{ item.starttime_text }}</span>
					<span class="column">{{ item.endtime_text }}</span>
					<span class="column" style="color: rgb(0, 240, 240);">
						{{ item.status == 0 ? $t('进行中') : $t('已完成') }}
					</span>
					<span class="column">{{ item.name }}</span>
					<!-- <span class="column">
						<span class="syxq">{{ $t('收益详情') }}</span>
					</span> -->
				</div>
			</div>
			<div class="dtk" v-else>{{ $t('没有更多数据了') }}</div>
		</div>

		<oPage v-if="page.total > page.limit" :current-page.sync="page.page" :page-size.sync="page.limit"
			:total="page.total" @current-change="getdata" />
	</div>
</template>

<script>
import { get } from '@/http/request'
import apis from '@/http/api'
import oPage from '@/common/pc/oPage.vue'
import titleModel from './components/title.vue';
export default {
	components: {
		titleModel, oPage
	},
	data() {
		return {
			status: '1',
			list: [],
			page: {
				page: 1,
				limit: 10,
				total: 10,
			},
		};
	},
	created() {
		this.getdata()
	},
	watch: {
		status() {
			this.page.page = 1
			this.getdata()
		}
	},
	methods: {
		handleClick() { },

		getdata(showLoading = true) {
			get(apis.getQuantOrderList, {
				showLoading,
				...this.page,
				status: this.status - 1,
			}).then(res => {
				if (res.code != 1) return
				this.list = res.data
				this.page.total = res.data.total || 0
			})
		},
	},
};
</script>
<style lang="scss" scoped>
.list-page {
	padding: 0 20px 20px;
	text-align: center;
	min-height: 250px;
	// margin: 0px 0 30px;

	.tr-div {
		.row {
			display: flex;
			align-items: center;
			justify-content: center;
			margin-bottom: 2px;
			font-size: 14px;
			border-bottom: 1px solid #2c2c3e;
		}
	}

	.th-div {
		height: 60px;
		line-height: 60px;
		font-size: 14px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 2px;
		color: #fff;
		border-bottom: 1px solid #2c2c3e;
	}

	.column {
		flex: 1;
		min-height: 60px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.syxq {
		padding: 0 10px;
		line-height: 34px;
		text-align: center;
		border-radius: 5px;
		color: #000;
		height: 34px;
		background: #00f0ff;
		cursor: pointer;
	}

	.dtk {
		width: 100%;
		height: 100px;
		line-height: 100px;
		text-align: center;
		color: #888;
	}
}
</style>